module.exports = __webpack_public_path__ + "static/media/decor_aqua2_medium.e5d8f00b.png";